$(function () {
    // "Our Story" page year navigation

    // Get current window Y offset
    let scrollPosition = $(this).scrollTop();

    // Get first year anchor
    const firstPosition = $('.about-sw__anchor').first().offset().top;

    // For each year anchor, check if scroll position is greater than anchor position
    // Then remove .active class and re-add to the nav link with that anchor id
    // If scrolled to top, remove all .active classes from nav links
    function getScrollPosition() {
        $('.about-sw__anchor').each(function () {
            const anchorPosition = $(this).offset().top;
            const id = $(this).attr('id');
            if (scrollPosition >= anchorPosition - 64) {
                $('#storyNav > ul > li > a').removeClass('active');
                $(`#storyNav > ul > li > a[href=\\#${id}]`).addClass('active');
            } else if (scrollPosition < firstPosition) {
                $('#storyNav > ul > li > a').removeClass('active');
            }
        });
    }

    // Check location on page load
    getScrollPosition();

    // Check location on scroll
    $(window).on('scroll', function () {
        scrollPosition = $(this).scrollTop();
        getScrollPosition();
    });

    // Smooth scroll to anchor link, remove url hash
    $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on('click', function (event) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
            location.hostname === this.hostname
        ) {
            let target = $(this.hash);
            target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top,
                }, 1000, function () {
                    const element = target.get(0);
                    element.focus({ preventScroll: true });
                    if (document.activeElement !== element) {
                        element.setAttribute('tabindex', '-1');
                        element.focus({ preventScroll: true });
                    }
                });
            }
        }
    });
});
